import { pure, lifecycle, compose, getContext, renderNothing } from 'recompose';
import PropTypes from 'prop-types';

const ymaps = window.ymaps;

function receiveGeomProps(geom, propToPropMap, propToOptionMap, props, nextProps) {
  Object.keys(propToPropMap).forEach(prop => {
    if (nextProps[prop] !== props[prop]) {
      const propname = propToPropMap[prop];
      if (propname) {
        geom.properties.set(propname, nextProps[prop]);
      }
    }
  });
  Object.keys(propToOptionMap).forEach(prop => {
    if (nextProps[prop] !== props[prop]) {
      const propname = propToOptionMap[prop];
      if (propname) {
        geom.options.set(propname, nextProps[prop]);
      }
    }
  });
}

const mapGeometry = (type, propToPropMap, propToOptionMap) => compose(
  getContext({
    getGeoCollection: PropTypes.func.isRequired,
  }),
  lifecycle({
    componentWillMount() {
      const { coords, collection, getGeoCollection } = this.props;
      this.geoObject = new ymaps[type](coords);
      this.geoObject.events.add('click', event => {
        if (this.props.onClick) {
          this.props.onClick(event);
        }
      });
      this.geoObject.events.add('mouseenter', event => {
        if (this.props.onMouseEnter) {
          this.props.onMouseEnter(event);
        }
      });
      this.geoObject.events.add('mousemove', event => {
        if (this.props.onMouseMove) {
          this.props.onMouseMove(event);
        }
      });
      receiveGeomProps(this.geoObject, propToPropMap, propToOptionMap, {}, this.props);
      this.collection = collection || (getGeoCollection && getGeoCollection());
      this.collection.add(this.geoObject);
    },
    componentWillReceiveProps(nextProps) {
      const { coords } = nextProps;
      if (coords && coords !== this.props.coords) {
        this.geoObject.geometry.setCoordinates(coords);
      }
      receiveGeomProps(this.geoObject, propToPropMap, propToOptionMap, this.props, nextProps);
    },
    componentWillUnmount() {
      // this.collection.remove(this.geoObject);
    },
  }),
  renderNothing,
);

export const Polyline = pure(mapGeometry(
  'Polyline',
  {
    hintContent: 'hintContent',
  },
  {
    visible: 'visible',
    strokeColor: 'strokeColor',
    strokeWidth: 'strokeWidth',
    strokeOpacity: 'strokeOpacity',
    strokeStyle: 'strokeStyle',
  },
)());

export const Placemark = pure(mapGeometry(
  'Placemark',
  {
    iconCaption: 'iconCaption',
    balloonContent: 'balloonContent',
    hintContent: 'hintContent',
  },
  {
    visible: 'visible',
    preset: 'preset',
    iconCaptionMaxWidth: 'iconCaptionMaxWidth',
  },
)());



// WEBPACK FOOTER //
// ./src/components/Map/MapGeoObjects.jsx